import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faBuilding, faHandshake, faLocationArrow, faRocket, faUser } from '@fortawesome/free-solid-svg-icons';
import '../styles/Statistics.css';
import { STATS_CENTRE, STATS_CUSTOMER, STATS_FARMERS, STATS_LOCATION, STATS_PARTNERS, STATS_PRODUCTS } from '../data/navbar/menu';
import { useTranslation } from 'react-i18next';
import JumboContainer from './common/JumboContainer';

const statsDetails = [
  {
    icon: faBuilding,
    number: 40,
    detail: STATS_CENTRE,
  },
  {
    icon: faUser,
    number: 90000,
    detail: STATS_FARMERS
  },
  {
    icon: faLocationArrow,
    number: 15,
    detail: STATS_LOCATION
  },
  {
    icon: faBriefcase,
    number: 200,
    detail: STATS_CUSTOMER
  },
  {
    icon: faRocket,
    number: 2000,
    detail: STATS_PRODUCTS
  },
  {
    icon: faHandshake,
    number: 100,
    detail: STATS_PARTNERS
  }
]

const Stats = ({icon, number, detail}) => {

  const {t} = useTranslation();

  return (
    <div class="stats" id="stats">
      <FontAwesomeIcon icon={icon} color={'#14a79e'} size="2x"/>
      <h2 class="number">
        {number}
      </h2>
      <div class="details">
        {t(detail)}
      </div>
    </div>
  )
}

const Statistics = () => {

  return (
    <JumboContainer white>
      <div class="stats-list">
        {statsDetails.map(stat => 
          <Stats icon={stat.icon} number={stat.number} detail={stat.detail} />
        )}
      </div>
    </JumboContainer>
  )
}

export default Statistics;